import { render, staticRenderFns } from "./ScreenTranslucenciaNucalPerfilCervical.vue?vue&type=template&id=6edeb5a0&scoped=true&"
import script from "./ScreenTranslucenciaNucalPerfilCervical.vue?vue&type=script&lang=js&"
export * from "./ScreenTranslucenciaNucalPerfilCervical.vue?vue&type=script&lang=js&"
import style0 from "./ScreenTranslucenciaNucalPerfilCervical.vue?vue&type=style&index=0&id=6edeb5a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edeb5a0",
  null
  
)

export default component.exports